import { PricingPlanCard } from './PricingPlanCard';
import { PricingPlan } from './pricingPlans.config';
import { cn } from '@/Domain/utils/cn';
import { StripeData } from '@/UI/Subscription/Subscription.page';

type Props = {
  plans: PricingPlan[];
  isBillingYearly: boolean;
  stripeData: StripeData;
  onFaqLink: (faqKey: string) => void;
  testId: string;
};

// Enterprise widens to fill its row instead of leaving an empty slot next to it.
const customPlanSpan = (index: number): string =>
  cn(index % 2 === 0 && 'sm:col-span-2', index % 4 === 3 ? 'lg:col-span-1' : 'lg:col-span-2');

export const PricingPlanGrid = ({
  plans,
  isBillingYearly,
  stripeData,
  onFaqLink,
  testId,
}: Props) => (
  <div
    className="grid grid-cols-1 items-stretch gap-4 sm:grid-cols-2 lg:grid-cols-4"
    data-testid={testId}
  >
    {plans.map((plan, index) => (
      <PricingPlanCard
        key={plan.key}
        plan={plan}
        isBillingYearly={isBillingYearly}
        stripeData={stripeData}
        onFaqLink={onFaqLink}
        className={plan.isCustom ? customPlanSpan(index) : undefined}
      />
    ))}
  </div>
);
